import React from "react";

import {
  Route,
  createRoutesFromElements,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";


import BaseLayout from "./components/layout/baseLayout/BaseLayout";
import Homepage from "./pages/regular/homepage/Homepage";
import Register from "./pages/regular/register/Register";
import ForgotPassword from "./pages/regular/forgotPassword/ForgotPassword";
import 'primeicons/primeicons.css';
import "./App.css";
// import "@fontsource/roboto";

import Courses from "./pages/regular/courses/Courses";
import CourseInfo from "./pages/regular/courseInfo/CourseInfo";

import BuyCourse from "./pages/regular/buyCourse/BuyCourse";
import ApprovedTransaction from "./pages/regular/approvedTransaction/ApprovedTransaction";
import DeniedTransaction from "./pages/regular/deniedTransaction/DeniedTransaction";
import Contribution from "./pages/regular/contribution/Contribution"

import Profile from "./pages/regular/profile/Profile";
import MyCourses from "./pages/regular/myCourses/MyCourses";
import TransferenceRequested from "./pages/regular/transferenceRequested/TransferenceRequested";
import ZoomMeeting from "./pages/regular/ZoomMeeting/ZoomMeeting";
import MyOrders from "./pages/regular/myOrders/MyOrders";
import CreditCardPaymentQuote from "./pages/regular/creditCardPaymentQuote/CreditCardPaymentQuote";
import ChangeTemporalPassword from "./pages/regular/changeTemporalPassword/ChangeTemporalPassword";
import ErrorPage from "./pages/regular/errorPage/ErrorPage";


function App() {
  const routeDefinitions = createRoutesFromElements(
    <Route>
      <Route path="*" element={<ErrorPage />} />
      <Route
        path="/"
        element={<BaseLayout />}
        children={[
          <Route key="Home" path="/" element={<Homepage/>} />,
          <Route key="NextCourses" path="/courses/:categories" element={<Courses/>} />,
          <Route key="CourseInfo" path="/courseinfo/:courseid" element={<CourseInfo/>} />,
          <Route key="MyCourses" path="/mycourses" element={<MyCourses/>} />,
          <Route key="Profile" path="/profile" element={<Profile/>} />,
          <Route key="BuyCourse" path="/purchase/:courseid" element={<BuyCourse/>} />,
          <Route key="ApprovedTransaction" path="/approvedTransaction" element={<ApprovedTransaction/>} />,
          <Route key="DeniedTransaction" path="/deniedTransaction" element={<DeniedTransaction/>} />,
          <Route key="TransferenceRequested" path="/transferenceRequested" element={<TransferenceRequested/>} />,
          <Route key="Meeting" path="/meeting/:courseid" element={<ZoomMeeting/>} />,
          <Route key="Register" path="/register" element={<Register/>} />,
          <Route key="ForgotPassword" path="/forgotPassword/:userId/:token" element={<ForgotPassword/>} />,
          <Route key="Contribution" path="/contribution/:courseid" element={<Contribution/>} />,
          <Route key="orders" path="/orders" element={<MyOrders/>} />,
          <Route key="creditCardPaymentQuote" path="/payQuote/:ordenid/:courseid" element={<CreditCardPaymentQuote/>} />,
          <Route key="changepassword" path="/changepassword" element={<ChangeTemporalPassword/>} />,

        ]}
      />
    </Route>
  );
  const router = createBrowserRouter(routeDefinitions);

  return <RouterProvider router={router} />;
}
export default App;
